var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groupItem.error)?_c('small',{staticClass:"error-label"},[_vm._v(_vm._s(_vm.groupItem.error))]):_c('span',{staticClass:"numbers"},[_vm._v("\n  "+_vm._s(_vm.groupItem.sms)+" texts, "+_vm._s(_vm.groupItem.email)+" emails\n")])}
var staticRenderFns = []

export { render, staticRenderFns }